export default function Header({ onLogout }) {
  return (
    <nav className="navbar navbar-dark bg-dark flex-shrink-0 py-1">
      <div className="container-fluid px-3">
        <span className="navbar-brand mb-0 small">DEHC Admin</span>
        <button onClick={onLogout} className="btn btn-outline-light btn-sm">Logout</button>
      </div>
    </nav>
  );
}
